export enum RequestFormType {
    FORM        = 1,            // public FORM  'form'
    REQUEST     = 2             // 'request' - INTERNAL REQUEST
}

export enum RequestFormFieldType {
    TASK    = 'task', // both system and custom ?
    FORM    = 'form'
}

export enum RequestForm_FieldTreatAs {
    USER_NAME   = 'user-name',
    USER_EMAIL  = 'user-email',
    USER_PHONE  = 'user-phone',
}